import { render, staticRenderFns } from "./StatisticTable.vue?vue&type=template&id=a454209e&"
import script from "./StatisticTable.vue?vue&type=script&lang=js&"
export * from "./StatisticTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports